module.exports = {"blocks":[{"name":"Text","description":"Text block, default, centered","componentName":"TextBlock","editComponentName":"Edit-TextBlock"},{"name":"Image","description":"Image component","componentName":"ImageBlock","editComponentName":"Edit-ImageBlock"},{"name":"Video","description":"Video component","componentName":"VideoBlock","editComponentName":"Edit-VideoBlock"},{"name":"TwoCol","description":"Image/Text","componentName":"TwoColBlock","editComponentName":"Edit-TwoColBlock"},{"name":"Html","description":"Html block","componentName":"HtmlBlock","editComponentName":"Edit-HtmlBlock"}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/blocks.json
// module id = kl0P
// module chunks = 1